import { Box, Tooltip } from '@mui/material';
import { IDefaultIconProps } from '../../types/index';
import { AppStore } from '../store/AppStore';
import { isFeatureActive } from 'services/ClaimsHelper';
import defaultIcon from '../assets/svg/defaultIcon.svg';

export const DefaultIcon = (props: IDefaultIconProps): React.ReactElement | null => {
  const claimsData = AppStore.getState().claimsData;

  // Don't show icon if DisplayConfigurationState feature is inactive.
  if (!isFeatureActive(claimsData.featureFlags.DisplayConfigurationState)) {
    return null;
  }

  return props.show ? (
    <Box
      sx={{
        position: 'absolute',
        left: '-34px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '3px',
      }}
    >
      <Tooltip title="Default Value">
        <Box
          component="img"
          src={defaultIcon}
          sx={{
            height: '1.3em',
            width: '1.3em',
            display: 'block',
          }}
        ></Box>
      </Tooltip>
    </Box>
  ) : (
    <></>
  );
};
